import React, { useState, useEffect, useRef } from "react";
import { BiChevronDown, BiChevronRight } from "react-icons/bi";
import Pagereview from "../../components/pageReview/Pagereview";

const DubaiMedicalRegistry = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabsRef = useRef(null);
  useEffect(() => {
    const currentTabs = tabsRef.current;
    if (currentTabs) {
      const handler = (event) => {
        setActiveTab(event.detail);
      };
      currentTabs.addEventListener("tabClick", handler);
      return () => currentTabs.removeEventListener("tabClick", handler);
    }
  }, []);
const breadcrumbData = [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Dubai Medical Registry",
      icon: "home",
      url: "/healthdubai/dubaiMedicalRegistry",
    },

    {
      text:
        activeTab === 0
          ? "Healthcare Professionals" :
          "Healthcare Facilities",
      icon: "menu_book",
      url: "/healthdubai/dubaiMedicalRegistry",
    },
  ];

  const [expandedFilters, setExpandedFilters] = useState({
    gender: true,
    licenseType: false,
    category: false,
    specialty: false,
    language: false,
    facility: false,
    nationality: false,
    area: false,
  });

  const healthcareProfessionals = [
    {
      id: 1,
      name: "Dr. Marwan Al Mulla",
      specialty: "Family Medicine",
      image: "https://209.126.6.128:4454/attachments/medialib/53bb2e54-4346-4837-aa02-6f2f8e7f1b6b-1760447163389-449479657-DHA-CEO.jpg",
      gender: "male",
    },
    {
      id: 2,
      name: "Dr. Marwan Al Mulla",
      specialty: "Family Medicine",
      image: "https://209.126.6.128:4454/attachments/medialib/53bb2e54-4346-4837-aa02-6f2f8e7f1b6b-1760447163389-449479657-DHA-CEO.jpg",
      gender: "male",
    },
    {
      id: 3,
      name: "Dr. Marwan Al Mulla",
      specialty: "Family Medicine",
      image: "https://209.126.6.128:4454/attachments/medialib/53bb2e54-4346-4837-aa02-6f2f8e7f1b6b-1760447163389-449479657-DHA-CEO.jpg",
      gender: "male",
    },
  ];
  const healthcareFacilities = [
    {
      id: 1,
      name: "Dubai Healthcare City Clinic",
      type: "Clinic",
      image: "https://209.126.6.128:4454/attachments/medialib/53bb2e54-4346-4837-aa02-6f2f8e7f1b6b-1760447163389-449479657-DHA-CEO.jpg",
      rating: 4.5,
    },
    {
      id: 2,
      name: "Emirates Hospital",
      type: "Hospital",
      image: "https://209.126.6.128:4454/attachments/medialib/53bb2e54-4346-4837-aa02-6f2f8e7f1b6b-1760447163389-449479657-DHA-CEO.jpg",
      rating: 4.2,
    },
    {
      id: 3,
      name: "Medcare Medical Center",
      type: "Medical Center",
      image: "https://209.126.6.128:4454/attachments/medialib/53bb2e54-4346-4837-aa02-6f2f8e7f1b6b-1760447163389-449479657-DHA-CEO.jpg",
      rating: 4.0,
    },
  ];
  const facilityFilters = ["Facility Type", "Area", "Rating"];

 

  const toggleFilterExpansion = (category) => {
    setExpandedFilters((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  return (
    <div className="">
      <dda-breadcrumb
        key={activeTab}
        design="text"
        separator="chevron_right"
        custom_class=""
        component_mode=""
        data-breadcrumbs={JSON.stringify(breadcrumbData)}
      ></dda-breadcrumb>
      <h2 className="md:!my-4 my-2 Medium  text-primary">
        Dubai Medical Registry
      </h2>
      <h5 className="md:!my-4 my-2 Regular text-onSurfaceVariant">
        Find Healthcare Professionals or Healthcare Facilities based on your
        needs!
      </h5>

      <dda-tabs
        ref={tabsRef}
        type="text"
        hover_style="dda-tab-underline-filled"
        custom_class="mb-4"
        component_mode=""
        button_id="button"
        aria_label="tabs"
        tab_texts='["Healthcare Professionals","Healthcare Facilities"]'
        ontabclick="index => alert(`Tab ${index + 1} clicked!`)"
        val="value"
        button_name="button"
      ></dda-tabs>
      {activeTab === 0 && (
        <div className="md:flex gap-8">
          <div className="md:w-80  rounded-lg border border-outline p-6 overflow-y-auto md:max-h-none max-h-[300px] md:mb-0 mb-4">
            <div className="flex items-center justify-between mb-6">
              <h6 className="">Filter</h6>
              <button className="text-primary body hover:underline">
                Close
              </button>
            </div>

            <div className="mb-6">
              <button
                className="flex items-center justify-between w-full text-start body  mb-3"
                onClick={() => toggleFilterExpansion("gender")}
              >
                Gender
                <BiChevronDown
                  className={`transform transition-transform text-2xl ${
                    expandedFilters.gender ? "rotate-180" : ""
                  }`}
                />
              </button>
              {expandedFilters.gender && (
                <div className="space-y-3">
                  <label className="flex items-center justify-between">
                    <dda-checkbox
                        id="female"
                      title_text="Female"
                      checked="false"
                      style_type="fill"
                      supporting=""
                      group_name="checkboxgroup"
                      input_id="femaleId"
                      aria_label="checkbox"
                      custom_class=""
                      component_mode=""
                      onclick=""
                    ></dda-checkbox>
                    <span className="small border rounded-full  w-8 h-6 pt-[1px] text-center">
                      14
                    </span>
                  </label>
                  <label className="flex items-center justify-between">
                    <dda-checkbox
                      title_text="Male"
                      checked="false"
                      style_type="fill"
                      size="md"
                      supporting=""
                      group_name="checkboxgroup"
                      input_id="maleId"
                      aria_label="checkbox"
                      custom_class=""
                      component_mode=""
                      onclick=""
                    ></dda-checkbox>
                    <span className="small border rounded-full  w-8 h-6 pt-[1px] text-center">
                      78
                    </span>
                  </label>
                </div>
              )}
            </div>

            {[
              "License Type",
              "Category",
              "Specialty",
              "Language",
              "Facility",
              "Nationality",
              "Area",
            ].map((category) => {
              const key = category.toLowerCase().replace(" ", "");
              return (
                <div key={category} className="mb-6">
                  <button
                    className="flex items-center justify-between w-full text-start body  mb-3"
                    onClick={() => toggleFilterExpansion(key)}
                  >
                    {category}
                    <BiChevronDown
                      className={`transform transition-transform text-2xl ${
                        expandedFilters[key] ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                </div>
              );
            })}
          </div>

          <div className="flex-1">
            <dda-search-input
              placeholder="Search"
              size="default"
              validation_id=""
              show_button="true"
              has_error="false"
              custom_class=""
              component_mode=""
              button_id="button"
              input_id="Search"
              aria_label="search-input"
              button_aria_label="clear-search"
              onchange=""
              search_input_name="search-input"
              close_button_name="close-button"
              search_button_name="search-button"
              button_text="Search"
            ></dda-search-input>

            <div className="flex flex-col gap-3 mt-3">
              {healthcareProfessionals.map((professional) => (
                <div
                  key={professional.id}
                  className="flex items-center justify-between hover:bg-gray-50 transition-colors border border-outline rounded-lg cursor-pointer"
                  onClick={() => {
                    window.location.href =
                      "/healthdubai/dubaiMedicalRegistryDetail";
                  }}
                >
                  <div className="flex items-center space-x-4 ">
                    <img
                      src={professional.image}
                      alt={professional.name}
                      className="w-40 h-32 rounded-s-lg object-cover"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                    <div className="p-4">
                      <h5 className="font-medium mb-1">{professional.name}</h5>
                      <p className="body text-onSurfaceVariant">
                        {professional.specialty}
                      </p>
                    </div>
                  </div>
                  <BiChevronRight className="text-4xl border rounded-lg p-1 me-3" />
                </div>
              ))}
            </div>

            <div className="flex justify-between items-center my-4">
              <div>
                Showing 1 to 10 of 97 results
              </div>
                <dda-pagination
                  total_pages="8"
                  current_page="1"
                  type="text-pages"
                  custom_class=""
                  component_mode=""
                  simple_slider_prev_button=""
                  simple_slider_next_button=""
                  buttons_prev_button=""
                  buttons_next_button=""
                  text_prev_button=""
                  text_next_button=""
                  text_pages_prev_button=""
                  text_pages_next_button=""
                  button_text_prev_button=""
                  button_text_next_button=""
                  buttons_pages_prev_button=""
                  buttons_pages_next_button=""
              ></dda-pagination>
            </div>
          </div>
        </div>
      )}

      {activeTab === 1 && (
        <div className="md:flex gap-8">
          <div className="w-80 bg-white rounded-lg border border-outline p-6">
            <div className="flex items-center justify-between mb-6">
              <h6 className="">Filter</h6>
              <button className="text-primary body hover:underline">
                Close
              </button>
            </div>

            <div className="mb-6">
              <button
                className="flex items-center justify-between w-full text-start body mb-3"
                onClick={() => toggleFilterExpansion("facilityType")}
              >
                Facility Type
                <BiChevronDown
                  className={`transform transition-transform text-2xl ${
                    expandedFilters.facilityType ? "rotate-180" : ""
                  }`}
                />
              </button>
              {expandedFilters.facilityType && (
                <div className="space-y-3">
                  <label className="flex items-center justify-between">
                    <dda-checkbox
                      title_text="Clinic"
                      checked="false"
                      size="md"
                      style_type="fill"
                      supporting=""
                      group_name="checkboxgroup"
                      input_id="facility1"
                      aria_label="checkbox"
                      custom_class=""
                      component_mode=""
                    ></dda-checkbox>
                    <span className="small border rounded-full  w-8 h-6 pt-[1px] text-center">
                      10
                    </span>
                  </label>
                  <label className="flex items-center justify-between">
                    <dda-checkbox
                      title_text="Hospital"
                      checked="false"
                      size="md"
                      style_type="fill"
                      supporting=""
                      group_name="checkboxgroup"
                      input_id="facility2"
                      aria_label="checkbox"
                      custom_class=""
                      component_mode=""
                    ></dda-checkbox>
                    <span className="small border rounded-full  w-8 h-6 pt-[1px] text-center">
                      12
                    </span>
                  </label>
                </div>
              )}
            </div>

            {facilityFilters.slice(1).map((category) => {
              const key = category.toLowerCase().replace(" ", "");
              return (
                <div key={category} className="mb-6">
                  <button
                    className="flex items-center justify-between w-full text-start body mb-3"
                    onClick={() => toggleFilterExpansion(key)}
                  >
                    {category}
                    <BiChevronDown
                      className={`transform transition-transform text-2xl ${
                        expandedFilters[key] ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                </div>
              );
            })}
          </div>

          <div className="flex-1">
            <dda-search-input
              placeholder="Search"
              size="default"
              validation_id=""
              show_button="true"
              has_error="false"
              custom_class=""
              component_mode=""
              button_id="button"
              input_id="FacilitySearch"
              aria_label="search-input"
              button_aria_label="clear-search"
              onchange=""
              search_input_name="search-input"
              close_button_name="close-button"
              search_button_name="search-button"
              button_text="Search"
            ></dda-search-input>

            <div className="flex flex-col gap-3 mt-3">
              {healthcareFacilities.map((facility) => (
                <div
                  key={facility.id}
                  className="flex items-center justify-between hover:bg-gray-50 transition-colors border border-outline rounded-lg cursor-pointer"
                  onClick={() => {
                    window.location.href =
                      "/healthdubai/dubaiMedicalRegistry";
                  }}
                >
                  <div className="flex items-center space-x-4">
                    <img
                      src={facility.image}
                      alt={facility.name}
                      className="w-40 h-32 rounded-s-lg object-cover"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                    <div className="p-4">
                      <h5 className="font-medium mb-1">{facility.name}</h5>
                      <p className="body text-onSurfaceVariant">
                        {facility.type}
                      </p>
                    </div>
                  </div>
                  <BiChevronRight className="text-4xl border rounded-lg p-1 me-3" />
                </div>
              ))}
            </div>

            <div className="flex justify-between items-center my-4">
              <div>
                Showing 1 to 10 of 97 results
              </div>
                <dda-pagination
                  total_pages="8"
                  current_page="1"
                  type="text-pages"
                  custom_class=""
                  component_mode=""
                  simple_slider_prev_button=""
                  simple_slider_next_button=""
                  buttons_prev_button=""
                  buttons_next_button=""
                  text_prev_button=""
                  text_next_button=""
                  text_pages_prev_button=""
                  text_pages_next_button=""
                  button_text_prev_button=""
                  button_text_next_button=""
                  buttons_pages_prev_button=""
                  buttons_pages_next_button=""
              ></dda-pagination>
            </div>
          </div>
        </div>
      )}

      
    </div>
  );
};

export default DubaiMedicalRegistry;
